import React, { useRef, useEffect, useState } from 'react';
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar,Image,Selector,Grid
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../MsgAdd/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    PostMedias,GetPlanetInfo
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};


const VideoWithRandomThumbnail = ({ videoUrl }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [thumbnailUrl, setThumbnailUrl] = useState('');

    useEffect(() => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!video || !canvas) return;

        // 设置视频源
        video.src = videoUrl;

        // 当视频元数据加载后
        video.onloadedmetadata = () => {
            // 随机选择一个时间点（0到视频时长之间）
            const randomTime = Math.random() * video.duration;

            // 设置视频到随机时间点
            video.currentTime = randomTime;
        };

        // 当视频时间更新（到达随机时间点）
        video.onseeked = () => {
            const ctx = canvas.getContext('2d');
            // 设置canvas尺寸与视频相同
            canvas.width = 110;
            canvas.height = 110;
            // 绘制当前帧到canvas
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            // 将canvas转为图片URL
            setThumbnailUrl(canvas.toDataURL('image/jpeg'));
        };

        // 清理函数
        return () => {
            video.onloadedmetadata = null;
            video.onseeked = null;
        };
    }, [videoUrl]);

    return (
        <div>
            {/* 隐藏的视频元素 */}
            <video
                ref={videoRef}
                style={{ display: 'none' }}
                crossOrigin="anonymous" // 如果需要处理跨域视频
            />

            {/* 隐藏的canvas元素 */}
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            {/* 显示封面图片 */}
            {thumbnailUrl ? (
                <img
                    src={thumbnailUrl}
                    alt="Video thumbnail"
                    style={{ width: '100%', height: 'auto' }}
                />
            ) : (
                    <div>加载中...</div>
                )}
        </div>
    );
};
  


class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            videos: [],
            totalCount: 0,
            page: 0,
            pageSize: 50,
            hasMore: true,
            loading: false,
            initialLoading: false,
            isAdmin: false,
            planetInfo: {},
        };
    }

    componentDidMount() {
        var that = this;

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
            })

            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var isAdmin = false;
                    if (res.result.openId == localStorage.getItem("openid")) {
                        isAdmin = true;
                    } else {
                        var items = res.result.planetFamilyGroupDtos
                            .filter(x => x.openId == localStorage.getItem("openid"));
                        if (items.length > 0) {
                            isAdmin = items[0].isAdmin;
                        }
                    }

                    that.setState({
                        isAdmin: isAdmin,
                        planetInfo: res.result,
                    })
                }
            })

            this.setState({ initialLoading: true }, () => {
              this.loadPosts();
            });

        }


        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }
    
    loadPosts = async () => {
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数

        var that = this;
        const { page, pageSize, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            PlanetId: id,
            OpenId: "",
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
        };

        try {
            PostMedias(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    // newPosts.map(item => {
                    //     item.fileUrl = environment.apiEndpoint + "/NNFiles/Video/" + item.fileUrl;
                    //     item.creationTime = dayjs(item.creationTime).format('YYYY年MM月DD日')
                    // })

                    const groupedPosts = newPosts
                        .map(item => ({
                            ...item,
                            fileUrl: environment.apiEndpoint + "/NNFiles/Video/" + item.fileUrl,
                            formattedDate: dayjs(item.creationTime).format('YYYY年MM月DD日'),
                            originalTime: item.creationTime // 保留原始时间用于排序
                        }))
                        .reduce((acc, item) => {
                            // 查找是否已存在该日期的分组
                            const group = acc.find(g => g.date === item.formattedDate);

                            if (group) {
                                // 如果分组已存在，添加到该分组的list中
                                group.list.push(item);
                            } else {
                                // 如果分组不存在，创建新分组
                                acc.push({
                                    date: item.formattedDate,
                                    list: [item]
                                });
                            }
                            return acc;
                        }, [])
                        .map(group => ({
                            ...group,
                            // 对每个日期的视频按原始时间排序（从新到旧）
                            list: group.list.sort((a, b) => new Date(b.originalTime) - new Date(a.originalTime))
                        }))
                        // 对所有日期组按日期排序（从新到旧）
                        .sort((a, b) => new Date(b.date.replace(/[年月日]/g, '/')) - new Date(a.date.replace(/[年月日]/g, '/')));

                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;

                    that.setState({
                        videos: [...that.state.videos, ...groupedPosts],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        loading: false
                    });
                }
            })
        } catch (error) {
            console.error('加载留言失败:', error);
            this.setState({
                initialLoading: false, loading: false
            });
        }
    }


    render() {


        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    var planetId = this.state.id;
                    if (planetId == null || planetId == undefined) {
                        const { location } = this.props;
                        const { id } = location.state || {}; // 获取 URL 参数
                        planetId = id;
                    }
                    this.props.navigate('/home?planetId=' + planetId, { replace: true, state: { id: planetId } }); // 传递状态
                }} style={{ borderBottom: 'solid 1px #e4e4e4', 'height': "6%" }}>
                    视频列表
                </NavBar>


                <div style={{
                    width: "100%", height: "85%", backgroundColor: "rgb(195 195 195)", overflowY: "scroll"
                }}>

                    <div style={{ width: "90%", marginLeft: "5%" }}>

                        {
                            this.state.videos.map(item1 => {
                                return (<div>
                                    <div style={{ paddingTop: "5%", fontSize: "17px" }}>
                                        {item1.date}
                                    </div>
                                    <Grid columns={3}>
                                        {
                                            item1.list.map(item => {
                                                return (<Grid.Item span={1}>
                                                    <div style={{
                                                        marginTop: "5%", position: "relative", display: "flex",
                                                        justifyContent: "center", alignItems: "center"
                                                    }} onClick={() => {
                                                        this.props.navigate('/videoInfo', {
                                                            replace: true, state: {
                                                                id: item.id,
                                                                planetId: this.state.id
                                                            }
                                                        }); // 传递状态
                                                    }}>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/4/47-10.png"}
                                                            fit='fill' width={20} height={20} style={{
                                                                position: "absolute",
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)"
                                                            }} />
                                                        <VideoWithRandomThumbnail videoUrl={item.fileUrl} />
                                                    </div>
                                                </Grid.Item>)
                                            })
                                        }


                                    </Grid>
                                </div>)
                            })
                        }

                    </div>


                    <div style={{ marginTop: "15%", marginBottom: "5%" }}>
                        <div style={{
                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                            , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                            , fontWeight: "600", color: "#fff"
                        }} onClick={() => {
                            if (this.state.isAdmin) {
                                this.props.navigate('/videoAdd', { replace: true, state: { planetId: this.state.id } }); // 传递状态
                            } else {
                                Toast.show({ icon: 'fail', content: '请联系星球管理员进行上传！' });
                            }
                        }}>
                            视 频 上 传
                            </div>
                        <div style={{ textAlign: "center", margin: "6px 0px 1px 0px" }}>
                            温馨提示：
                            </div>
                        <div style={{ textAlign: "center" }}>
                            单次上传视频不能超过30M，可以上传多个。
                            </div>
                    </div>

                </div>

                <BottomMenu selectKey="home" position="absolute" />

            </div>
        )
    }
}

export default withNavigate(Index);